import axioPath from '../../../api/axioPath';
import { SIGN_IN, CHANGE_PASSWORD, ACCOUNT_ACTIVATION, CARD_EXPIRY_DETAILS, USER_INFO_DETAILS } from '../action_types';
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const auth = (data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/v2/auth/login', data)
    //.post('/auth/login', data)
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: SIGN_IN, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

export const refreshTokenApiCall = (refreshTokenVal, token) => (dispatch) => {
  let data = {
    refreshToken: refreshTokenVal
  }
  return axioPath
    .post('/users/refreshtoken', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      return response.data;
    }).catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const getBetaUsersList = () => (dispatch) => {
  const token = localStorage.getItem("token");
  dispatch(showAppLoader())
  return axioPath
    .get('/user/location/beta-users', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: "STORE_BETA_USERS_LIST", payload1: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

export const storeCardExpiryDetails = (buyer, seller, subscription) => ({
  type: CARD_EXPIRY_DETAILS,
  payload1: buyer,
  payload2: seller,
  payload3: subscription,
});

export const accountActivation = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/users/account-activation?token=' + `${token}`)
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: ACCOUNT_ACTIVATION, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};
export const acknowledgeApi = (name, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/users/acknowledged?name=' + name, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: ACCOUNT_ACTIVATION, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const acknowledgeLatestVersionApi = (emailId, nameVal, data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/users/tcsubmit', data, {
      headers: {
        Authorization: `${token}`,
        email: emailId,
        name: nameVal
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const getTermsAndConditionsApi = ({ token, userRole }) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get(`/termsandconditions/findlatesttandc/${userRole}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: "STORE_TERMS_AND_CONDITIONS", payload1: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const getTermsAndConditionsAcknowledgeDetails = (emailId, token) => (dispatch) => {
  return axioPath
    .get('/users/tcdetails', {
      headers: {
        email: emailId,
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch({ type: "STORE_TERMS_AND_CONDITIONS_ACKNOWLEDGE_DETAILS", payload1: response.data });
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const palletCombination = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/order/image/Pallet Combination Table 3.28.2022.xlsx', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: ACCOUNT_ACTIVATION, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

//upload spec file
export const uploadSpecFileDetails = (token, formData) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/rfp/specfile/readSpecFile', formData, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

//get spec file details
export const getSpecFileDetails = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/v2/specification/all_specification_details', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

export const changePassword = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/users/forgot-password-reset-link-verify', data, {
      headers: {
        token: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: CHANGE_PASSWORD, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

export const signOutApi = (refreshTokenVal) => (dispatch) => {
  let data = {
    refreshToken: refreshTokenVal
  }
  return axioPath
    .post('/users/signout', data)
    .then((response) => {
      return response.data;
    }).catch((ex) => {
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

export const logoutClearRedux = () => ({
  type: 'RESET_REDUX_STORE',
});


//get spec file details
export const getSpecFileDetailsV2 = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/v2/specification/get_specification_files_details', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};